module.exports = __webpack_public_path__ + "static/media/0008.09a5b2b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48107/RAL/0008.png
// module id = 2638
// module chunks = 0